import React, { useState, useEffect, useContext, useRef, useMemo, useCallback } from "react";
// import { Container, Row, Col } from "react-bootstrap";
import { Container, Row, Col, Modal, Button } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";

import logo from '../images/logo.png';
import toglogo from '../images/together-logo.png';
import { Contaxt } from "../../../Store";

import { apiBaseURL, apiURL, apiKey } from "./../../../constant";
import Dropdown from "react-bootstrap/Dropdown";
import Marquee from "react-fast-marquee";

const Header = () => {
  const { marquee, marqueeSlug, userData, userLogout, cartItmeNum } = useContext(Contaxt);
  const [searchPopup, setPopupSearch] = useState({ status: false, text: "", list: [], isEmpty: false });
  const [listening, setListening] = useState(false);
  const [showVoiceModal, setShowVoiceModal] = useState(false);
  const controller = useRef(null);
  const debounceTimer = useRef(null);
  const recognitionRef = useRef(null);
  const navigate = useNavigate();

  // Initialize SpeechRecognition once
  useEffect(() => {
    const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
    if (!SpeechRecognition) {
      console.warn("Web Speech API is not supported in this browser.");
      return;
    }
    const recog = new SpeechRecognition();
    recog.lang = 'en-US';        // change to 'hi-IN' for Hindi
    recog.interimResults = false;
    recog.continuous = false;

    recog.onstart = () => console.log("Speech recognition started");
    recog.onresult = (event) => {
      const transcript = event.results[0][0].transcript;
      console.log("Transcript:", transcript);
      // setText(transcript);
      setText(transcript);
    };
    recog.onerror = (event) => {
      console.error("Speech recognition error", event.error);
      // setListening(false);
      setListening(false);
      setShowVoiceModal(false);
    };
    recog.onend = () => {
      console.log("Speech recognition ended");
      // setListening(false);
      setListening(false);
      setShowVoiceModal(false);
    };

    recognitionRef.current = recog;

    // Cleanup on unmount
    return () => {
      if (controller.current) controller.current.abort();
      if (debounceTimer.current) clearTimeout(debounceTimer.current);
      if (recognitionRef.current) {
        recognitionRef.current.onstart = null;
        recognitionRef.current.onresult = null;
        recognitionRef.current.onerror = null;
        recognitionRef.current.onend = null;
        recognitionRef.current = null;
      }
    };
  }, []);

  // Cleanup controller and debounce timer on unmount
  useEffect(() => {
    return () => {
      if (controller.current) {
        controller.current.abort();
      }
      if (debounceTimer.current) {
        clearTimeout(debounceTimer.current);
      }
    };
  }, []);

  const searchBooks = useCallback((text) => {
    if (text.trim() === "") return;
    controller.current = new window.AbortController();
    fetch(`${apiBaseURL}${apiURL.searchBooks}?SearchKey=${encodeURIComponent(text)}`, {
      signal: controller.current.signal,
      method: "GET",
      headers: { rskey: apiKey },
    })
      .then(res => res.json())
      .then(res => {
        if (res.status === "1") {
          setPopupSearch(prev => ({
            ...prev,
            list: res.products,
            isEmpty: false,
            status: true
          }));
        } else {
          setPopupSearch(prev => ({
            ...prev,
            list: [],
            isEmpty: true,
            status: true
          }));
        }
      })
      .catch(err => {
        if (err.name !== "AbortError") console.error("Fetch error", err);
      });
  }, []);

  const setText = (text) => {
    setPopupSearch(prev => ({ ...prev, text, status: true }));
    if (controller.current) {
      controller.current.abort();
      controller.current = null;
    }
    if (debounceTimer.current) {
      clearTimeout(debounceTimer.current);
    }
    debounceTimer.current = setTimeout(() => searchBooks(text), 300);
  };

  const startListening = () => {
    if (recognitionRef.current && !listening) {
      try {
        // recognitionRef.current.start();
        // setListening(true);
        setListening(true);
        setShowVoiceModal(true);
        recognitionRef.current.start();
      } catch (e) {
        console.error("Start error", e);
        setListening(false);
        setShowVoiceModal(false);
      }
    }
  };

  const stopListening = () => {
    if (recognitionRef.current && listening) {
      recognitionRef.current.stop();
      setListening(false);
    }
  };

  const hideList = () => {
    setTimeout(() => {
      setPopupSearch((prev) => ({ ...prev, status: false }));
    }, 300);
  };

  const closePopup = () => {
    setPopupSearch((prev) => ({ ...prev, status: false, text: "", list: [], isEmpty: false }));
  };

  const openPopup = () => {
    setPopupSearch((prev) => ({ ...prev, status: true }));
  };

  const goToBookPage = (e) => {
    e.preventDefault();
    if (!searchPopup.text.trim()) return;
    closePopup();
    navigate(`/books/cbse?search=${encodeURIComponent(searchPopup.text)}`);
  };

  const bookLists = useMemo(() => (
    <>
      {searchPopup.list.map((item) => (
        <React.Fragment key={item.productId}>
          <Link
            to={`/${item.catSlug}/${item.slug}?type=p_book&id=${item.productId}`}
            style={{ cursor: "pointer" }}
            onClick={closePopup}
          >
            <Row>
              <Col md={1} sm={1} xs={2}>
                <img
                  src={item.main_image}
                  alt={`Cover of ${item.product_title}`}
                  loading="lazy"
                  decoding="async"
                  style={{ width: "100%", height: "auto" }}
                />
              </Col>
              <Col md={11} xs={10}>
                <p className="booklist-desi">{item.product_title}</p>
              </Col>
            </Row>
          </Link>
          <div className="order-border"></div>
        </React.Fragment>
      ))}
    </>
  ), [searchPopup.list]);

  return (
    <div className="App">
      <Row>
        <div className="top-bar">
          <center>
            <Col md={6} xs={11}>
              <Marquee direction="left" speed={48} pauseOnHover>
                <Link to={marqueeSlug}>
                  <p>{marquee}</p>
                </Link>
              </Marquee>
            </Col>
          </center>
        </div>
      </Row>

      <Container fluid>
        <div className="logo-section">
          <Row>
            <Col md={3} sm={12} xs={8}>
              <div className="logo">
                <Link to="/"> <img src={logo} alt="Site Logo" loading="eager" decoding="async" /> </Link>
              </div>
            </Col>
            <Col md={6} sm={6}>
              <div className="searchpopup">
                <form onSubmit={goToBookPage} autoComplete="off" className="displyflex">
                  <input
                    type="text"
                    placeholder="Search.."
                    name="search"
                    onChange={(e) => setText(e.target.value)}
                    value={searchPopup.text}
                    onFocus={openPopup}
                    onBlur={hideList}
                    aria-label="Search books"
                  />
                  <button type="submit">
                    <i className="fa fa-search" aria-hidden="true"></i>
                  </button>

                  <button type="button" onClick={listening ? stopListening : startListening}
                    className={`voice-btn ${listening ? 'listening' : ''}`} aria-label="Voice Search">
                    <i className="fa fa-microphone" />
                  </button>
                </form>
                {searchPopup.status && (
                  <div className="book-list">
                    {searchPopup.list.length === 0 && searchPopup.isEmpty && (
                      <div style={{ minHeight: "50px", textAlign: "center", paddingTop: "10px" }}>
                        No book found!
                      </div>
                    )}
                    {bookLists}
                  </div>
                )}
              </div>
            </Col>
            <Col md={3} sm={6} className="right-login">
              <span className="cart">
                <Link to="/orderDetail">
                  <i className="fa fa-shopping-cart chatsho" aria-hidden="true"></i>
                </Link>
                <span className="cartcount" style={{ display: cartItmeNum === 0 ? "none" : "inline" }}>
                  {cartItmeNum}
                </span>
              </span>

              {userData.loginStatus ? (
                <>
                  {userData.isLoading ? (
                    <div style={{ textAlign: "center", margin: "2px 12px 0 0", display: "inline" }}>
                      <span className="spinner-grow spinner-grow-sm"></span>
                    </div>
                  ) : (
                    <Dropdown className="header-login" style={{ display: "inline" }}>
                      <Dropdown.Toggle id="dropdown-basic" className="login">
                        {userData.name}
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        <Dropdown.Item onClick={userLogout}>Logout</Dropdown.Item>
                        <Dropdown.Item>
                          <Link to="/profile/account">
                            <span>Profile</span>
                          </Link>
                        </Dropdown.Item>
                        <Dropdown.Item>
                          <Link to="/profile/wishlist">
                            <span>Wishlist</span>
                          </Link>
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  )}
                </>
              ) : (
                <Link to="/account/login">
                  <button type="button" className="login">
                    Login &nbsp;<i className="fa fa-user favi" aria-hidden="true"></i>
                  </button>
                </Link>
              )}
              <span className="together">
                <img
                  src={toglogo}
                  alt="Together Logo"
                  loading="lazy"
                  decoding="async" />
              </span>
            </Col>
          </Row>

          {/* ===== Voice Listening Modal ===== */}
          <Modal
            show={showVoiceModal}
            onHide={() => { recognitionRef.current.stop(); }}
            centered
            backdrop="static"
            keyboard={false}
          >
            <Modal.Body className="text-center">
              <i
                className={`fa fa-microphone fa-3x ${listening ? "listening-animation" : ""
                  }`}
                aria-hidden="true"
              />
              <p className="mt-3">Listening…</p>
              {searchPopup.text && (
                <p className="font-italic">“{searchPopup.text}”</p>
              )}
              <Button variant="secondary" onClick={() => recognitionRef.current.stop()}>
                Stop
              </Button>
            </Modal.Body>
          </Modal>
        </div>
      </Container>
    </div>
  );
};

export default Header;
